import React from "react";
import { useNavigate } from "react-router-dom";
const ViewAllBrandsButton = () => {
  const navigate = useNavigate();

  const handleClick = (path) => {
    navigate(path);
  };
  return (
    <div style={{ display: "flex" }}>
      <button className="view-brands-btn" onClick={() => handleClick("/allBrands")}>
        View All Brands
        <span className="arrow">→</span>
      </button>
      <button
        className="view-brands-btn"
        onClick={() => handleClick("/advanced-metrics")}
      >
        Advanced Metrics
        <span className="arrow">→</span>
      </button>
      <button
        className="view-brands-btn"
        onClick={() => handleClick("/manage-access-list")}
      >
        Manage Access List
        <span className="arrow">→</span>
      </button>
      <button
        className="view-brands-btn"
        onClick={() => handleClick("/usage-stats")}
      >
        Usage Stats
        <span className="arrow">→</span>
      </button>
    </div>
  );
};
export default ViewAllBrandsButton;
